import React from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import FilePreviewer from '../FilePreviewer/FilePreviewer';
import { XIcon, PreviewIcon } from '@forwardfinancing/component-library';
import colors from '../../../constants/colors';
import utils from '../../../lib/utils';

export class FileUploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renderSingleFilePreviewer: false
    };

    this.closeFilePreviewerModal = this.closeFilePreviewerModal.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  removeFileFromList(e) {
    const filesToBeUploaded = this.props.filesToBeUploaded;
    let fileIndex = e.target.getAttribute('data-file-index') ||
      e.target.closest("a").getAttribute('data-file-index');
    filesToBeUploaded.splice(fileIndex, 1);
    this.props.setFiles(filesToBeUploaded);
  }

  onDrop(files) {
    // on each file added, add to state not just replace
    const currentFilesAndNewFiles = this.props.filesToBeUploaded.concat(files);
    this.props.setFiles(currentFilesAndNewFiles);
    if (this.props.additionalOnDropAction) {
      this.props.additionalOnDropAction(files);
    }
  }

  renderPreviewer() {
    return(
      this.state.renderSingleFilePreviewer ?
        <FilePreviewer
          file={this.state.fileToPreview}
          renderAllPages={true}
        />
        : null
    );
  }

  previewFile(e) {
    let fileIndex = e.target.getAttribute('data-file-index') ||
      e.target.closest("a").getAttribute('data-file-index');
    this.setState({
      renderSingleFilePreviewer: true,
      fileToPreview: this.props.filesToBeUploaded[fileIndex]
    });
  }

  renderUploadedFileList(files) {
    let fileList = null;
    if (this.props.filesToBeUploaded.length > 0) {
      fileList = (
        <div className="file-uploader__uploaded-list-wrap">
          <h2
            className="file-uploader__uploaded-list-item-title"
          >
            Files To Be Uploaded
          </h2>
          <table className="file-uploader__uploaded-list-table">
            <thead className="file-uploader__uploaded-list-header">
              <tr className="file-uploader__uploaded-list-header-row">
                <th className="file-uploader__uploaded-list-table-name">Document Name</th>
                <th className="file-uploader__uploaded-list-table-type">Document Type</th>
                <th className="file-uploader__uploaded-list-table-preview"/>
                <th className="file-uploader__uploaded-list-table-x"/>
              </tr>
            </thead>
            <tbody className="file-uploader__uploaded-list-body">
              {
                files.map((f, i) =>
                  <tr
                    key={i}
                    className="file-uploader__uploaded-list-body-row"
                  >
                    <td title={f.name} className="file-uploader__uploaded-list-table-name">
                      {utils.truncateTitle(f.name, 28)}
                    </td>
                    <td className="file-uploader__uploaded-list-table-type">
                      {f.tag || ""}
                    </td>
                    <td className="file-uploader__uploaded-list-table-preview">
                      <a
                        className="file-uploader__uploaded-list-table-preview-button"
                        data-file-index={i}
                        onClick={this.previewFile.bind(this)}
                        type="button"
                      >
                        <PreviewIcon
                          width="24px"
                          height="24px"
                        />
                      </a>
                    </td>
                    <td className="file-uploader__uploaded-list-table-x">
                      <a
                        className="file-uploader__uploaded-list-action-button"
                        data-file-index={i}
                        onClick={this.removeFileFromList.bind(this)}
                        type="button"
                      >
                        <XIcon
                          fill={colors.red}
                          width="24"
                          strokeWidth="2"
                        />
                      </a>
                    </td>
                  </tr>
                )
              }
            </tbody>
          </table>
        </div>
      );
    }
    return (
      <div>
        <div
          className={`modal ${this.state.renderSingleFilePreviewer ? "is-active" : ""}`}
        >
          <div className="modal-component__background modal-background" onClick={this.closeFilePreviewerModal} />
          <a
            className="file-uploader__single-file-preview-close-button"
            onClick={this.closeFilePreviewerModal}
            type="button"
          >
            <XIcon
              fill={colors.white}
              width="64"
              strokeWidth="3"
            />
          </a>
          <div className="modal-component__content modal-card file-uploader__single-file-preview">
            {this.renderPreviewer()}
          </div>
        </div>
        <div className="fileList">
          {fileList}
        </div>
      </div>
    );
  }

  closeFilePreviewerModal(){
    this.setState({ renderSingleFilePreviewer: false });
  }

  /**
   * Close the previewer modal on Escape keypress
   * @param {Object} e keydown event
   */
  handleKeyPress(e){
    if (this.state.renderSingleFilePreviewer && e.key === "Escape") {
      this.closeFilePreviewerModal();
    }
  }

  renderFailedUploads(){
    const { failedUploads } = this.props;
    return (
      <div className="file-uploader__failed-uploads">
        <div className="file-uploader__info-title">
          Please retry to upload the following documents:
        </div>
        {
          failedUploads.map((file, index) => {
            return (
              <div key={index}>
                {file}
              </div>
            );
          })
        }
      </div>
    );
  }

  render() {
    const { failedUploads, uploadInstructions } = this.props;
    return (
      <div className="file-uploader" tabIndex="0" onKeyDown={this.handleKeyPress}>
        <div className="file-uploader__info">
          {
            failedUploads && failedUploads.length > 0 ?
            this.renderFailedUploads() :
            uploadInstructions
          }
        </div>
        <div className="file-uploader__drop-zone">
        <Dropzone
          onDrop={this.onDrop.bind(this)}
          style={{}} // this does look odd - but it makes the styles set by this component empty
          className="file-uploader__drop-zone-component"
         >
          <div>Drag & Drop</div>
          <div> or </div>
          <div className="button is-info">
            <div className="upload-icon">
              <div className="upload-arrow">
                &#x2191;
              </div>
              <div className="upload-box">
                &#9251;
              </div>
            </div>
            Upload
          </div>
          </Dropzone>
          <div>
            {this.renderUploadedFileList(this.props.filesToBeUploaded)}
          </div>
        </div>
      </div>
    );
  }
}

FileUploader.propTypes = {
  filesToBeUploaded: PropTypes.array,
  failedUploads: PropTypes.array,
  setFiles: PropTypes.func,
  uploadInstructions: PropTypes.object,
  shouldRenderFilePreviewer: PropTypes.bool,
  additionalOnDropAction: PropTypes.func
};

export default FileUploader;
